import { FiDownload, FiMenu } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { profile } from "../../data/profile";
import ThemeToggle from "../ui/ThemeToggle";
import { titleForPath } from "./nav";

const Topbar = ({ onOpenMobile }) => {
  const { pathname } = useLocation();
  const title = titleForPath(pathname);

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          type="button"
          className="icon-btn topbar-menu"
          onClick={onOpenMobile}
          aria-label="Open menu"
        >
          <FiMenu />
        </button>
        <div className="topbar-title">
          <span className="topbar-crumb">@{profile.username}</span>
          <span className="topbar-sep">/</span>
          <span className="topbar-page">{title}</span>
        </div>
      </div>

      <div className="topbar-right">
        <a
          className="lc-btn lc-btn-ghost topbar-cv"
          href={profile.resumePdf}
          download="Ravi_Kant_Sharma_CV.pdf"
        >
          <FiDownload /> <span>Download CV</span>
        </a>
        <ThemeToggle />
        <Link to="/" className="topbar-avatar" aria-label="Dashboard">
          <img src={profile.avatar} alt={profile.name} />
        </Link>
      </div>
    </header>
  );
};

export default Topbar;
